module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cq24C"))).then(() => parcelRequire('9Lwss'));